namespace $ {
	export let $mol_mem = $mol_wire_solo
	export let $mol_mem_key = $mol_wire_plex
}
